import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  TextField,
  Button,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const PostEntryFormData = ({
  errorObject,
  addProductForm,
  formData,
  handleChange,
  handleCheck,
  handleReset,
  handleSubmit,
  handleUpdate,
  ...props
}) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "post-entry";

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  function tabChangeHandler(event, newValue) {
    setValue(newValue);
  }

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const getRxLevel = (type = null) => {
    let level = "";

    if (formData.rxLevel) {
      level = formData.rxLevel;
    }
    return level;
  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading text-center">
              <div className="sw_heading_title_inner">
                {DispensingLanguage[lan][menukey]["Post - Add/Edit"]}
              </div>
            </div>
          </Grid>
        </div>

        {/* New row */}
        <Grid container spacing={3}>
          {/* New row */}
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardHeader
                title={DispensingLanguage[lan][menukey]["Post Information"]}
              />
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={4}>
                        {" "}
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField variant="standard"
                          disabled={!!props.permissionType}
                          error={!!errorObject.PostName}
                          helperText={errorObject.PostName}
                          required
                          id="PostName"
                          name="PostName"
                          label={DispensingLanguage[lan][menukey]["Post Name"]}
                          // value={formData.LastName || "Islam"}
                          value={formData.PostName}
                          fullWidth
                          autoComplete="family-name"
                          onChange={(e) => handleChange(e)}
                        />
                      </Grid>

                      <Grid item xs={4} sm={4}></Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Action buttons */}
          {addProductForm ? (
            <Grid item xs={12} className="mt-4 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => handleReset()}
              >
                {DispensingLanguage[lan][menukey]["Reset"]}
              </Button>
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleSubmit()}
              >
                {DispensingLanguage[lan][menukey]["Save"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/post-entry")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          ) : (
            <Grid item xs={12} className="mt-2 text-center">
              <Button
                disabled={!!props.permissionType}
                className="me-2"
                variant="contained"
                color="primary"
                onClick={() => handleUpdate()}
              >
                {DispensingLanguage[lan][menukey]["update"]}
              </Button>
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/post-entry")}
              >
                {DispensingLanguage[lan][menukey]["Cancel"]}
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default PostEntryFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
